import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Shield, Stethoscope, Sparkles, ArrowUpRight, ArrowRight, Building2 } from "lucide-react";
import { api } from "@/lib/api";
import { ThemeToggle } from "@/components/ThemeToggle";

export default function Landing() {
  const [hospitals, setHospitals] = useState([]);
  useEffect(() => { api.listHospitals().then(setHospitals).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 sm:pt-16 pb-16">
        <header className="flex items-center justify-between mb-16">
          <div className="text-[11px] uppercase tracking-[0.16em] font-semibold text-muted-foreground inline-flex items-center gap-1.5">
            <Sparkles className="w-3 h-3" /> Surgeon.ai
          </div>
          <ThemeToggle />
        </header>

        <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-semibold px-3 py-1 rounded-full border border-border bg-secondary">
          Demo MVP
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight mt-6 max-w-3xl leading-tight">
          A white-label surgical recovery platform.
          <span className="block text-muted-foreground font-medium mt-2">One codebase. Every hospital's brand.</span>
        </h1>
        <p className="text-muted-foreground mt-6 max-w-2xl">
          Frictionless patient portals, editable AI-drafted recovery plans, and a clinical triage dashboard —
          dynamically branded to each partner hospital via the URL.
        </p>
        <div className="flex flex-wrap gap-3 mt-8">
          <Link to="/super-admin" data-testid="link-super-admin"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-foreground text-background font-medium text-sm">
            <Shield className="w-4 h-4" /> Super-Admin <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="mt-16">
          <div className="text-[11px] uppercase tracking-[0.14em] text-muted-foreground font-semibold mb-4 flex items-center gap-2">
            <Building2 className="w-3.5 h-3.5" /> Try a hospital portal
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {hospitals.map((h) => (
              <div key={h.code} className="surface-card overflow-hidden shadow-sm">
                <div className="p-5 border-b border-border">
                  <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.14em] text-muted-foreground font-medium">
                    <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: h.primary_color }} />
                    {h.logo_text || h.name}
                  </div>
                  <div className="text-xl font-semibold mt-1">{h.name}</div>
                  <div className="text-xs text-muted-foreground mt-1">code · <span className="font-mono">{h.code}</span></div>
                </div>
                <div className="p-4 flex flex-wrap gap-2">
                  <Link to={`/${h.code}/doctor`} data-testid={`landing-doctor-${h.code}`}
                    className="inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded-full border border-border bg-card hover:bg-secondary">
                    <Stethoscope className="w-3 h-3" /> Doctor <ArrowUpRight className="w-3 h-3" />
                  </Link>
                  <Link to={`/${h.code}/admin`} data-testid={`landing-admin-${h.code}`}
                    className="inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded-full border border-border bg-card hover:bg-secondary">
                    Admin <ArrowUpRight className="w-3 h-3" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
